import { render, staticRenderFns } from "./ArticleClassGridList.vue?vue&type=template&id=99a2a1d6"
import script from "./ArticleClassGridList.vue?vue&type=script&lang=js"
export * from "./ArticleClassGridList.vue?vue&type=script&lang=js"
import style0 from "./ArticleClassGridList.vue?vue&type=style&index=0&id=99a2a1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports